import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map-route-length",
  "use": "icon-map-route-length-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-map-route-length\">\n<g>\n\t<path d=\"M15.1,9.5l-2.2-4c-0.4-0.7-1.4-0.7-1.7,0l-2.2,4H15.1z\" />\n\t<polygon points=\"6.1,14.5 17.9,14.5 15.7,10.5 8.3,10.5 \t\" />\n\t<path d=\"M18.5,15.5H5.5l-1.7,3C3.5,19.2,3.9,20,4.7,20h14.6c0.8,0,1.2-0.8,0.9-1.5L18.5,15.5z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol